import React from 'react'
import { Tooltip } from 'antd'
import PropTypes from 'prop-types'
import { InformationIcon, Span } from './styles'
import { Text } from '../../../../constants/TextConstants'

import 'antd/dist/antd.css'
const iconSize = 25

export function TitleWithTooltip({ titleText = '', tooltipText = '', placement = 'rightTop', ...rest }) {
  return (
    <Tooltip title={tooltipText} placement={placement} {...rest} >
      <Span>
        {titleText}
      </Span>
      <InformationIcon size={iconSize} />
    </Tooltip>
  )
}

export function TitleWithTooltipAboutAddingSkills({ title = '', ...rest }) {
  return <TitleWithTooltip titleText={title} tooltipText={Text.ForAddingNewOptionsContactHead} {...rest} />
}

TitleWithTooltipAboutAddingSkills.propTypes = {
  title: PropTypes.string.isRequired
}

TitleWithTooltip.propTypes = {
  titleText: PropTypes.string.isRequired,
  tooltipText: PropTypes.string.isRequired,
  placement: PropTypes.string
}
